<template>
  <div v-if="$ability.can('read', 'Owner')">
    <div v-if="loadingList">
      <AppSkeletonTable></AppSkeletonTable>
    </div>
    <div v-else>
      <DataTable :value="results" responsiveLayout="stack">
        <Column
          header="Nome"
          field="name"
          :sortable="true"
          headerStyle="width: 150px"
        />
        <Column header="Documento" field="document" :headerStyle="headerStyle">
          <template #body="{ data: { document } }">
            <span v-if="document">
              {{
                document.length === 11
                  ? $formatCPF(document)
                  : $formatCNPJ(document)
              }}
            </span>
            <span v-else> - </span>
          </template>
        </Column>
        <Column header="Contatos" headerStyle="width: 200px">
          <template #body="{ data: { phone, cellPhone, email } }">
            <span v-if="phone || cellPhone || email">
              <span v-if="phone">
                Telefone: {{ $formatPhone(phone) }}<br />
              </span>
              <span v-if="cellPhone">
                Celular: {{ $formatCellPhone(cellPhone) }}<br />
              </span>
              <span v-if="email"> Email: {{ email }} <br /> </span>
            </span>
            <span v-else> - </span>
          </template>
        </Column>
        <Column header="Endereço" headerStyle="width: 150px">
          <template #body="{ data: { address } }">
            <span style="max-width: 60%">
              {{ address?.address || '-' }}, {{ address?.number || '-' }} -
              {{ address?.district || '-' }}, {{ address?.city || '-' }} -
              {{ address?.state || '-' }},
              {{ address?.zipCode ? $formatZipCode(address?.zipCode) : '-' }}
            </span>
          </template>
        </Column>
        <Column
          header="Ações"
          :headerStyle="headerStyle"
          alignFrozen="right"
          :frozen="true"
        >
          <template #body="{ data: { id } }">
            <router-link
              :to="
                $ability.can('write', 'Owner')
                  ? { name: 'owner.edit', params: { id } }
                  : ''
              "
              style="text-decoration: none"
            >
              <Button
                :disabled="!$ability.can('write', 'Owner')"
                type="button"
                icon="pi pi-pencil"
                class="p-button-text p-button-secondary p-mr-1"
              ></Button>
            </router-link>
            <Button
              type="button"
              icon="pi pi-trash"
              class="p-button-text p-button-secondary"
              :disabled="!$ability.can('delete', 'Owner')"
              @click="showDeleteConfirm(results, id, 'name')"
            ></Button>
          </template>
        </Column>
      </DataTable>
      <Paginator
        :rows="query.pageSize"
        :totalRecords="pagination.total"
        @page="changeListPage({ page: $event.page + 1 })"
      ></Paginator>
      <router-link
        :to="{ name: 'owner.create' }"
        style="text-decoration: none"
        v-if="$ability.can('write', 'Owner')"
      >
        <AppFloatButton icon="pi pi-plus" />
      </router-link>
      <AppModalDelete
        type="Proprietário"
        :visible="deleteConfirm.visible"
        :item="deleteConfirm.item"
        @confirm="onDelete()"
        @cancel="hideDeleteConfirm()"
      ></AppModalDelete>
    </div>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import useDeleteConfirm from '../../lib/useDeleteConfirm';
import useApiList from '../../lib/useApiList';
import { OwnerApi } from '../../services/api';

export default {
  name: 'OwnerList',
  setup() {
    return {
      ...useApiList(OwnerApi, { include: '[stats]' }),
      ...useDeleteConfirm(),
    };
  },
  data() {
    return {
      headerStyle: 'width: 100px',
    };
  },
  async created() {
    await this.fetchList();
    this.$emitter.on('topbar-search', ({ query }) => {
      this.searchList(query);
    });
  },
  methods: {
    async onDelete() {
      try {
        await this.deleteListItem(this.deleteConfirm.id);
      } catch (error) {
        let detail = 'Não foi possível excluir o proprietário.';
        this.$toast.add({
          severity: 'error',
          summary: 'Desculpe!',
          detail,
          life: 3000,
        });
      }
      this.hideDeleteConfirm();
    },
  },
};
</script>

<style>
</style>